<template>
  <el-upload
    class="input imagen"
    :action="''"
    :class="{ 'inline-file-list': inlineFileList }"
    :auto-upload="false"
    v-model:file-list="uploadFiles"
    :on-change="onSelectFile"
    :accept="accept"
    :show-file-list="false"
    :list-type="showPreview ? 'picture': undefined"
    :disabled="disabled || limit === fileList.length"
    :multiple="multiple"
  >
  <el-button v-if="withBtn" size="small" :disabled="disabled || limit === fileList.length" :data-testid="buttonTestId">
    <span>{{ $t(labelTag) }}</span>
    <el-icon v-if="buttonIcon" class="uploadButtonIcon"><component :is="buttonIcon" /></el-icon>
  </el-button>
    <div v-else class="label" :data-testid="buttonTestId">{{ $t(labelTag) }}</div>
    
    <template #tip>
      <div class="el-upload__tip">
        <div class="fileContainer">
          <div v-for="(item, index) in fileList" :key="index" class="file">
            
            <el-icon :class="getItemIconClasses(item)"><component :is="getItemIcon(item)" /></el-icon>
            <span v-bind:class="item.uploadStatus === 'failed' ? 'error' : ''">{{ item.name }}</span>
            
            <span
              class="delete"
              :class="{ disabled: disabled || item.uploadStatus === 'pending' }"
              :aria-disabled="disabled || item.uploadStatus === 'pending'"
              @click="onRemoveFile(index)"
            ><el-icon><Close /></el-icon></span>
            <img v-if="showPreview && showPreviewAux" :src="item.url" @click="onImageClick(item)" style="margin-top: 6px; display: block" width="100">
          </div>
        </div>
      </div>
    </template>
  </el-upload>
</template>

<script>
  import { showError } from '../Mensaje'
  import { mostrarMensajeInternacionalizado, mostrarResultadoOperacion } from '../MensajeInternacionalizado/index'
  import { comprimirImagen } from './comprimirImagen'

  // límite por defecto de ASP.NET (maxRequestLength); por encima un servidor sin actualizar puede rechazar el pedido
  const TAMANIO_LIMITE_SERVIDOR_BYTES = 4096 * 1024

  export default {
    name: 'FileUpload',
    props: {
      name: { type: String, default: 'uploadInput' },
      labelTag: { type: String, default: 'FILE_UPLOAD_cargar_imagen' },
      files: { type: Array, default: () => [] },
      storeAction: { type: String, default: '' },
      temporalDeleteAction: { type: String, default: '' },
      temporalId: { type: [String, Number], default: '' },
      deferFileDeletion: { type: Boolean, default: false },
      numeroArchivo: { type: Number, default: 0 },
      onFileListChange: { type: Function, default: null },
      notifyPendingStatus: { type: Boolean, default: false },
      onFileRemoved: { type: Function, default: null },
      cargandoArchivo: { type: Function, default: null },
      onFileNameChange: { type: Function, default: null },
      accept: { type: String, default: '*' },
      withBtn: { type: Boolean, default: true },
      showPreview: { type: Boolean, default: false },
      limit: { type: Number, default: undefined },
      multiple: { type: Boolean, default: false },
      foro: { type: Boolean, default: false },
      garantia: { type: Boolean, default: false },
      buttonTestId: { type: String, default: '' },
      buttonIcon: { type: String, default: '' },
      inlineFileList: { type: Boolean, default: false },
      // tamaño máximo por archivo en KB (sin valor no se valida)
      maxSizeKB: { type: Number, default: undefined },
      // parámetros adicionales que se envían a la acción de upload
      uploadParams: { type: Object, default: () => ({}) },
      // redimensiona y recomprime las fotos jpg/png antes de subirlas
      comprimirImagenes: { type: Boolean, default: false },
      // se invoca con el máximo en KB que informa el back al rechazar una imagen por tamaño
      onMaxSizeKBChange: { type: Function, default: null },
      // impide adjuntar y quitar archivos (ej. mientras se guarda el formulario)
      disabled: { type: Boolean, default: false }
    },
    data() {
      return {
        fileList: this.inicializarLista(),
        uploadFiles: [],
        showPreviewAux: this.showPreview,
        fileExtension: undefined,
        arch: '',
        cargando: false,
        nextFileId: 0,
        resolvedTemporalId: this.temporalId
      }
    },
    watch: {
      files() {
        this.fileList = this.inicializarLista()
        this.syncUploadFilesFromFileList()
      },
      temporalId(value) {
        this.resolvedTemporalId = value
      }
    },
    mounted() {
      this.syncUploadFilesFromFileList()
    },
    beforeUnmount() {
      this.fileList.forEach((item) => {
        if (item.createdObjectUrl && item.url) {
          URL.revokeObjectURL(item.url)
        }
      })
    },
    methods: {
      syncUploadFilesFromFileList() {
        this.uploadFiles = this.fileList.map((item) => ({
          name: item.name,
          url: item.url
        }))
      },
      inicializarLista() {
        return this.files.map((x) => {
          const uploadStatus = x.uploadStatus || (
            x.error ? 'failed' : x.uploading ? 'pending' : 'uploaded'
          )

          return {
            name: x.name,
            url: x.url,
            uploadId: x.uploadId,
            uploadStatus,
            uploading: uploadStatus === 'pending',
            error: uploadStatus === 'failed',
            createdObjectUrl: false,
            temporalId: x.temporalId,
            existing: x.existing === true
          }
        })
      },
      async onSelectFile(file) {
        // verifico si se superó el máximo de archivos permitidos
        if(this.limit !== undefined && this.limit <= this.fileList.length)
        {
          showError(this.$t('FILE_UPLOAD_limite_exedido'))
          return
        }        
        // verifico que la extension pertenezca a las permitidas
        let valido = false;
        if(this.accept !== "*")
        {
          // armo el array con las extensiones permitidas pasadas en la propiedad 'accept'
          let extensiones = this.accept.split(',.');
          // obtengo la extension del archivo que se quiere subir
          //this.file_extension = 
          var file_extension = file.name.split('.').pop().toLowerCase();
          this.fileExtension = file_extension;
          
          if (this.garantia) {
            // let num = numeroArchivo;
             this.arch = file.name.split('.')[0]
          }

          // verifico que la extension del archivo que se quiere subir pertenezca a las extensiones permitidas
          if(extensiones.filter(x => x == file_extension).length > 0)
            valido = true;
          // Si es una imagen (png o jpg), mostramos la preview
          
          if(file_extension === 'png' || file_extension === 'jpg'){
            this.showPreviewAux = true;
          }else{ this.showPreviewAux = false; }
          
        }
        else
          valido = true
          
        // si no es valida la extension muestro un mensaje de error
        if(!valido)
        {
          showError(this.$t('FILE_UPLOAD_extension_no_permitida'));
          return
        }

        if(this.foro == true && this.cargandoArchivo) {this.cargandoArchivo(true)}
        // creo un nuevo item de file
        const fileUrl = file.url || (file.raw ? URL.createObjectURL(file.raw) : '')
        let fileItem = {
          name: file.name,
          url: fileUrl,
          uploadId: ++this.nextFileId,
          uploadStatus: 'pending',
          uploading: true,
          error: false,
          createdObjectUrl: !file.url && !!file.raw,
          temporalId: undefined,
          existing: false
        }
        this.fileList.push(fileItem)
        this.syncUploadFilesFromFileList()

        if (this.notifyPendingStatus) {
          this.listChanged(false)
        }

        // comprimo y valido el tamaño con el archivo pendiente en la lista, así no se puede confirmar mientras tanto
        const maxBytes = this.maxSizeKB ? this.maxSizeKB * 1024 : undefined
        let archivo = file.raw
        if (this.comprimirImagenes) {
          archivo = await comprimirImagen(file.raw, { maxBytes })
        }

        // valido el peso final (ya comprimido) antes de enviarlo al back
        if (maxBytes && archivo && archivo.size > maxBytes) {
          this.quitarArchivo(fileItem.uploadId)
          const fueComprimido = archivo !== file.raw
          showError(this.$t(fueComprimido ? 'FILE_UPLOAD_tamanio_excedido_comprimida' : 'FILE_UPLOAD_tamanio_excedido', {
            nombre: file.name,
            tamanio: (archivo.size / (1024 * 1024)).toFixed(1),
            maximo: Math.round((this.maxSizeKB / 1024) * 10) / 10
          }))
          return
        }

         let payload = {}

        if (this.garantia) {

          payload = {
          ...this.uploadParams,
          file: archivo,
          id: this.arch,
          numeroArchivo: this.numeroArchivo
        }
        } else {
          payload = {
          ...this.uploadParams,
          file: archivo,
          id: this.resolvedTemporalId,
          numeroArchivo: this.numeroArchivo
        }
        }

        // subo el archivo
        this.$store.dispatch(this.storeAction, payload)
        .then(data => { 
            const currentFileItem = this.fileList.find((item) => item.uploadId === fileItem.uploadId)
            if (!currentFileItem) return

            if(data && data.CodigoResultado === 0)
            {
              if (typeof data.Datos === 'string' && data.Datos.length > 0) {
                this.resolvedTemporalId = data.Datos
                currentFileItem.temporalId = data.Datos
              }
              currentFileItem.uploadStatus = 'uploaded'
              currentFileItem.uploading = false
              this.listChanged()
            }
            // Garantías rechazó la imagen por tamaño: la quito para que adjunten otra
            else if (this.garantia && data && data.CodigoResultado === -20)
            {
              const maxSizeKB = data.Datos && data.Datos.MaxTamanioImagenKB
              this.quitarArchivo(currentFileItem.uploadId)
              if (maxSizeKB > 0 && this.onMaxSizeKBChange) {
                this.onMaxSizeKBChange(maxSizeKB)
              }
              this.mostrarTamanioExcedido(file.name, maxSizeKB)
            }
            else
            {
              currentFileItem.uploadStatus = 'failed'
              currentFileItem.uploading = false
              currentFileItem.error = true
              if (this.garantia) {
                this.mostrarErrorSubida(file.name, data)
              }
              else if (data) {
                mostrarMensajeInternacionalizado(data.CodigoResultado, data.DescripcionResultado)
              }
              this.listChanged()
            }
          },
          error => {
            const currentFileItem = this.fileList.find((item) => item.uploadId === fileItem.uploadId)
            if (!currentFileItem) return

            currentFileItem.uploadStatus = 'failed'
            currentFileItem.uploading = false
            currentFileItem.error = true
            const errorData = error && error.response ? error.response.data : undefined
            if (this.garantia) {
              this.mostrarErrorHttpSubida(file.name, error, archivo && archivo.size)
            }
            else if (errorData) {
              mostrarMensajeInternacionalizado(errorData)
            }
            this.listChanged()
          }
        )
      },
      // errores de negocio de la subida a Garantías (HTTP 200 con CodigoResultado distinto de 0)
      mostrarErrorSubida(nombre, data) {
        // la descripción del -1 es técnica: muestro un mensaje genérico para reintentar
        if (data && data.CodigoResultado === -1)
          showError(this.$t('FILE_UPLOAD_error_guardado', { nombre }))
        else
          mostrarResultadoOperacion(data)
      },
      // la descripción del back usa el nombre temporal, así que armo el mensaje con el nombre real del archivo
      mostrarTamanioExcedido(nombre, maxSizeKB) {
        const maximoKB = maxSizeKB > 0 ? maxSizeKB : this.maxSizeKB
        if (maximoKB)
          showError(this.$t('FILE_UPLOAD_tamanio_excedido_maximo', { nombre, maximo: Math.round((maximoKB / 1024) * 10) / 10 }))
        else
          showError(this.$t('FILE_UPLOAD_tamanio_excedido_servidor', { nombre }))
      },
      mostrarErrorHttpSubida(nombre, error, tamanio) {
        const response = error && error.response
        const status = response && response.status
        const data = response && response.data
        const esTimeout = error && (error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT')

        // 401 y 403 ya los informa el interceptor de main.js
        if (status === 401 || status === 403)
          return

        // el pedido llegó sin la imagen
        if (status === 400) {
          showError(this.$t('FILE_UPLOAD_sin_imagen', { nombre }))
        }
        else if (data && data.CodigoResultado !== undefined) {
          this.mostrarErrorSubida(nombre, data)
        }
        // 413 del proxy o 404.13 de IIS (maxAllowedContentLength)
        // 500 de ASP.NET por maxRequestLength (por defecto 4 MB)
        else if (status === 413
          || (status === 404 && typeof data === 'string' && data.includes('404.13'))
          || (status === 500 && typeof data === 'string' && /Maximum request length exceeded|longitud m[aá]xima de la solicitud/i.test(data))) {
          showError(this.$t('FILE_UPLOAD_tamanio_excedido_servidor', { nombre }))
        }
        // IIS corta los pedidos grandes sin headers CORS (el navegador lo ve como error de red) y,
        // desde un cliente remoto, el 500 por tamaño llega con una página genérica: si el archivo era grande informo el tamaño
        else if ((!response || status === 500) && !esTimeout && tamanio > TAMANIO_LIMITE_SERVIDOR_BYTES) {
          showError(this.$t('FILE_UPLOAD_tamanio_excedido_servidor', { nombre }))
        }
        // errores de red, timeouts y respuestas sin el formato habitual
        else {
          showError(this.$t('FILE_UPLOAD_error_subida', { nombre }))
        }
      },
      quitarArchivo(uploadId) {
        const index = this.fileList.findIndex((item) => item.uploadId === uploadId)
        if (index === -1) return

        const item = this.fileList[index]
        if (item.createdObjectUrl && item.url) {
          URL.revokeObjectURL(item.url)
        }
        this.fileList.splice(index, 1)
        this.syncUploadFilesFromFileList()
        this.listChanged()
      },
      async onRemoveFile(index) {
        const item = this.fileList[index]

        if (!item || this.disabled || item.uploadStatus === 'pending') {
          return
        }

        const deferDeletion = this.deferFileDeletion && (item.existing || item.temporalId)

        if (this.temporalDeleteAction && item.temporalId && !deferDeletion) {
          try {
            const resultado = await this.$store.dispatch(this.temporalDeleteAction, {
              idTemporal: item.temporalId
            })
            if (!resultado || resultado.CodigoResultado !== 0) {
              mostrarMensajeInternacionalizado(resultado)
              return
            }
          } catch (error) {
            const errorData = error && error.response ? error.response.data : error
            mostrarMensajeInternacionalizado(errorData)
            return
          }
        }

        if (this.onFileRemoved) {
          this.onFileRemoved({ ...item })
        }

        if (item && item.createdObjectUrl && item.url) {
          URL.revokeObjectURL(item.url)
        }
        // quito el archivo de la lista
        this.fileList.splice(index, 1)
        this.syncUploadFilesFromFileList()
        this.listChanged()
      },
      listChanged(uploadFinished = true) {
        let fileNames = this.fileList.map((x) => {
          return {
            name: x.name,
            url: x.url,
            uploadId: x.uploadId,
            temporalId: x.temporalId,
            existing: x.existing,
            uploadStatus: x.uploadStatus,
            uploading: x.uploadStatus === 'pending',
            error: x.uploadStatus === 'failed'
          }
        })
        if (this.onFileListChange) {
          this.onFileListChange(this.name, fileNames)
        }
        if (uploadFinished && this.cargandoArchivo) {
          this.cargandoArchivo(false)
        }
      },
      getItemIcon(fileItem) {
        if(fileItem.uploadStatus === 'failed')
          return 'CircleCloseFilled'

        else if(fileItem.uploadStatus === 'pending')
          return 'Loading'

        else
          return 'SuccessFilled' 
      },
      getItemIconClasses(fileItem) {
        return ['status-icon', fileItem.uploadStatus === 'failed' ? 'icon-error' : fileItem.uploadStatus === 'pending' ? 'is-loading' : 'icon-success']
      },
      onImageClick(fileItem) {
        window.open(fileItem.url, '_blank')
      },
      iniciandoCarga() {
        this.cargando = true
      },
      finalizandoCarga() {
        this.cargando = false
      }
    }
  }
</script>

<style scoped>

.fileContainer {
  margin-top: 10px;
  display: grid;
}

.file {
  margin: 2px 0;
}

.file .el-icon.status-icon {
  margin-right: 5px;
}

.file .el-icon.is-loading {
  color: var(--main-color);
}

.file .el-icon.icon-success {
  color: #068806;
}

.file .el-icon.icon-error {
  color: #F44336;
}

.file .delete {
  float: right;
  cursor: pointer;
}
.file .delete.disabled {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}
.file .delete .el-icon {
  margin: 2px;
}

.file img {
  cursor: pointer;
}

.label {
  font-size: 13px;
  color: var(--main-color);
}

.inline-file-list {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  vertical-align: middle;
}

.inline-file-list :deep(.el-upload) {
  display: inline-flex;
  align-items: center;
}

.inline-file-list .fileContainer {
  margin-top: 0;
  margin-left: 0;
  display: inline-flex;
  align-items: center;
  line-height: 1;
}

.inline-file-list .file {
  margin: 0;
  display: inline-flex;
  align-items: flex-end;
  gap: 6px;
  line-height: 1;
}

.inline-file-list .file > span {
  line-height: 1;
  display: inline-flex;
  align-items: center;
}

.inline-file-list .file .delete {
  float: none;
  display: inline-flex;
  align-items: center;
}

.inline-file-list :deep(.el-upload__tip) {
  display: inline-flex;
  align-items: center;
  margin-top: 0 !important;
  margin-left: 8px;
  line-height: 1;
  height: auto;
  padding: 0;
}

.inline-file-list .filePreview {
  position: absolute;
  top: 0;
  left: 100%;
  margin-left: 8px;
  z-index: 1;
}

.filePreviewImage {
  display: block;
}

.uploadButtonIcon {
  margin-left: 6px;
  vertical-align: middle;
}
</style>